import { createRouter, createWebHistory } from 'vue-router'
import BadgePage from '@/badges/BadgePage'
import BadgesHome from '@/badges/BadgesHome'
import AwardBadge from '@/badges/AwardBadge'
import NotFound from '@/generic/NotFound'
import PrivacyPolicy from '@/generic/PrivacyPolicy'
import TermsOfUse from '@/generic/TermsOfUse'
import FAQ from '@/generic/FAQ'
import HomePage from '@/generic/HomePage'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: HomePage
    },
    {
      path: '/badges',
      name: 'BadgesHome',
      component: BadgesHome
    },
    {
      path: '/badges/award',
      name: 'AwardBadge',
      component: AwardBadge
    },
    {
      path: '/badges/user/:email',
      name: 'BadgePage',
      component: BadgePage
    },
    {
      path: '/terms',
      name: 'TermsOfUse',
      component: TermsOfUse
    },
    {
      path: '/privacy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy
    },
    {
      path: '/faq',
      name: 'FAQ',
      component: FAQ
    },
    {
      path: '/:pathMatch(.*)*',
      name: '404',
      component: NotFound
    }
  ]
})
export default router
